import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import {
  convertRegexFilterToBooleanFilter,
  convertRegexFilterToStartsWithFilter,
} from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import {
  ExchangeRuleScopeApplyToType,
  ExchangeRuleScopeEmailSelection,
  ExchangeContentControlAttachmentFilteringRule,
} from '@nirvana/shared/dtos/types/policies/common';

export interface ExchangeContentControlAttachmentFilteringRuleFrontendFields
  extends ExchangeContentControlAttachmentFilteringRule {
  applyTo: ExchangeRuleScopeApplyToType;
  senders: ExchangeRuleScopeEmailSelection;
  recipients: ExchangeRuleScopeEmailSelection;
}

export class GzExchangeContentControlAttachmentFilteringRulesGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ExchangeContentControlAttachmentFilteringRule
> {
  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert to boolean
    convertRegexFilterToBooleanFilter(request, ColumnKeys.STATUS);

    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    return;
  }

  protected getItemsWithAdditionalFrontendFields(
    items: ExchangeContentControlAttachmentFilteringRule[]
  ): ExchangeContentControlAttachmentFilteringRuleFrontendFields[] {
    return items.map(item => {
      return {
        ...item,
        applyTo: item.scope.applyTo,
        senders: item.scope.from,
        recipients: item.scope.to,
      };
    });
  }
}
